
import UnitCountOne from './../child/UnitCountOne';
import GeneratedContent from './../child/GeneratedContent';
import GeneratedUserContent from './../child/GeneratedUserContent';
import UserGrowthChart from './../child/UserGrowthChart';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { handleUnauthorized, showConfirmationDialog } from '../../utils/apiHelper';
import Loader from "./../child/Loder";

const DashBoardLayerOne = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const authToken = localStorage.getItem('authToken');
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {

    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/Dashboard`;
    try {
      setLoading(true);
      const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 401) {
        handleUnauthorized(navigate);;
        return;
      }
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const datas = await response.json();
      console.log(datas);
      setItems(datas.totals || []);
    } catch (error) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  };
  if (loading) return <Loader />;
  return (
    <>
      {/* UnitCountOne */}
      <UnitCountOne dashboardData={items} />
      {/* <section className="row gy-4 mt-1">
                  <GeneratedUserContent dashboardData={items}/>
                </section> */}

      <section className="row gy-4 mt-1">

        {/* <GeneratedContent dashboardData={items}/> */}


        <section className='col-md-6' >

        </section>
      </section>
      {/* <section className="row gy-4 mt-1">
               <Calender />
            </section>  */}
    </>


  )
}

export default DashBoardLayerOne